"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsColor = supportsColor;
const supports_color_1 = require("supports-color");
function supportsColor() {
    return Boolean(supports_color_1.stdout) && Boolean(supports_color_1.stderr);
}
